<template>
    <div class="feedbackReport">
        <BackButton />
        <v-container style="max-width:1000px">
            <div class="d-none d-md-flex">
                <div style="width:100%" class="progressOverview mb-5 mt-3">
                    <div class="syn_blue_button--text text-center pt-3 synThickFont">Sample Average Ratings of all User Submissions</div>
                    <!-- <div class="text-center synThickFont white--text pt-3" >
                        Overall <FeedbackPercentageSmall  class="mt-3 percBox" :rating="totalStats().overall" size="80" color="syn_blue_button"/>
                    </div> -->
                    <v-row no-gutters class="synThinFont white--text px-5 pb-5 pt-3" style="border-radius:5px; font-size:13px;">
                        <v-col class="text-center">
                            <span style="font-size:15px"> Mixing & Mastering </span> <FeedbackPercentageSmall  class="mt-3 percBox" :rating="70" size="60" color="syn_blue_button"/>
                        </v-col>
                        <v-col class="text-center">
                            <span style="font-size:15px">Melodies / Vocals </span> <FeedbackPercentageSmall class="mt-3 percBox" :rating="88" size="60" color="syn_blue_button"/>
                        </v-col>
                        <v-col class="text-center">
                            <span style="font-size:15px">Drums & Percussion</span> <FeedbackPercentageSmall class="mt-3 percBox" :rating="75" size="60" color="syn_blue_button"/>
                        </v-col>
                        <v-col class="text-center">
                            <span style="font-size:15px">Sound Design</span> <FeedbackPercentageSmall class="mt-3 percBox"  :rating="65" size="60" color="syn_blue_button"/>
                        </v-col>
                        <v-col class="text-center">
                            <span style="font-size:15px">Engagement</span> <FeedbackPercentageSmall class="mt-3 percBox" :rating="71" size="60" color="syn_blue_button"/>
                        </v-col>
                        <v-col class="text-center">
                            <span style="font-size:15px">Originality</span> <FeedbackPercentageSmall class="mt-3 percBox" :rating="82" size="60" color="syn_blue_button"/>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <!-- <div style="width:100%; margin-top:20px; margin-bottom:40px;height:1px; background-color:rgba(255,255,255,0.3); border-radius:15px"></div> -->
            <div class="white--text">
                <div class="mb-1 text-center">
                    <!-- <h2>Feedback Report</h2> -->
                    <div>
                        <h2 class="syn_blue_button--text">Sample Song</h2>
                    </div>

                    <v-avatar  size="100" class="my-2">
                        <v-img  src="https://firebasestorage.googleapis.com/v0/b/synthfeed-app.appspot.com/o/artists%2Fkuuro_profile.jpg?alt=media&token=6a15d70b-17aa-494a-b470-d264b924d30a"></v-img>
                    </v-avatar>
                    <div>
                        <span class="synThinFont">Feedback by: </span><router-link class="rl-no-dec syn_blue_button--text" :to="{ name: 'Artist', params: { artistId: 'e7md8b9OjhfAKAjNKzIb9ICjWQd2' }}">KUURO</router-link>
                    </div>
                    <div>
                        <span style="font-size:13px" class="synThinFont">Feedback for: </span><span style="font-size:13px" class=" syn_blue_button--text">Kivo Ribó</span>
                    </div>
                </div>
                <div class=" mb-5">
                    <br>
                    <div class="text-center">
                        <h2 class="synThickFont ">Overall</h2>
                        <FeedbackPercentage :rating="feedback.overall[0]" size="120" color="syn_blue_button"/>
                    </div>
                    <FeedbackComment class="criteriaCommentBox mb-5" :comment="feedback.overall[1]" />

                    <div class="d-none d-sm-flex">
                        <div>


                            <v-row  class="my-5 py-3">
                                <v-col sm="6" xs="12">
                                    <div class="text-center">
                                        <h3 class="synThickFont ">{{namings.mixingMastering}}</h3>
                                        <FeedbackPercentage  :rating="feedback.mixingMastering[0]" size="100" color="primary"/>
                                    </div>
                                    <FeedbackComment  class="criteriaCommentBox " :comment="feedback.mixingMastering[1]" />
                                </v-col>
                                <v-col sm="6" xs="12" >
                                    <div class="text-center">
                                        <h3 class="synThickFont ">{{namings.toplines}}</h3>
                                        <FeedbackPercentage  :rating="feedback.toplines[0]" size="100" color="primary"/>
                                    </div>
                                    <FeedbackComment class="criteriaCommentBox linkHoverSmall" :comment="feedback.toplines[1]" />
                                </v-col>
                            </v-row>

                            <v-row class="my-5 py-3">
                                <v-col sm="6" xs="12">
                                    <div class="text-center">
                                        <h3 class="synThickFont ">{{namings.drums}}</h3>
                                        <FeedbackPercentage   :rating="feedback.drums[0]" size="100" color="primary"/>
                                    </div>
                                    <FeedbackComment class="criteriaCommentBox" :comment="feedback.drums[1]" />
                                </v-col>
                                <v-col sm="6" xs="12" >
                                    <div class="text-center">
                                        <h3 class="synThickFont ">{{namings.soundDesign}}</h3>
                                        <FeedbackPercentage  :rating="feedback.soundDesign[0]" size="100" color="primary"/>
                                    </div>
                                    <FeedbackComment class="criteriaCommentBox" :comment="feedback.soundDesign[1]" />
                                </v-col>
                            </v-row>

                            <v-row class="my-5 py-3">
                                <v-col sm="6" xs="12">
                                    <div class="text-center">
                                        <h3 class="synThickFont ">{{namings.engagement}}</h3>
                                        <FeedbackPercentage  :rating="feedback.engagement[0]" size="100" color="primary"/>
                                    </div>
                                    <FeedbackComment class="criteriaCommentBox" :comment="feedback.engagement[1]" />
                                </v-col>
                                <v-col sm="6" xs="12" >
                                    <div class="text-center">
                                        <h3 class="synThickFont ">{{namings.originality}}</h3>
                                        <FeedbackPercentage  :rating="feedback.originality[0]" size="100" color="primary"/>
                                    </div>
                                    <FeedbackComment class="criteriaCommentBox" :comment="feedback.originality[1]" />
                                </v-col>
                            </v-row>
                        </div>
                    </div>

                    <div class="d-flex d-sm-none">
                        <div>


                            <v-row  class="my-5 py-3 px-3">
                                    <div class="text-center" style="margin-left:auto;margin-right:auto">
                                        <h3 class="synThickFont ">{{namings.mixingMastering}}</h3>
                                        <FeedbackPercentage  :rating="feedback.mixingMastering[0]" size="100" color="primary"/>
                                    </div>
                                    <FeedbackComment  class="criteriaCommentBox " :comment="feedback.mixingMastering[1]" />
                            </v-row>

                            <v-row  class="my-5 py-3 px-3">
                                    <div class="text-center" style="margin-left:auto;margin-right:auto">
                                    <h3 class="synThickFont ">{{namings.toplines}}</h3>
                                    <FeedbackPercentage  :rating="feedback.toplines[0]" size="100" color="primary"/>
                                </div>
                                <FeedbackComment class="criteriaCommentBox linkHoverSmall" :comment="feedback.toplines[1]" />
                            </v-row>


                            <v-row  class="my-5 py-3 px-3">
                                <div class="text-center" style="margin-left:auto;margin-right:auto">
                                    <h3 class="synThickFont ">{{namings.drums}}</h3>
                                    <FeedbackPercentage   :rating="feedback.drums[0]" size="100" color="primary"/>
                                </div>
                                <FeedbackComment class="criteriaCommentBox" :comment="feedback.drums[1]" />
                            </v-row>
                            <v-row  class="my-5 py-3 px-3">
                                <div class="text-center" style="margin-left:auto;margin-right:auto">
                                    <h3 class="synThickFont ">{{namings.soundDesign}}</h3>
                                    <FeedbackPercentage  :rating="feedback.soundDesign[0]" size="100" color="primary"/>
                                </div>
                                <FeedbackComment class="criteriaCommentBox" :comment="feedback.soundDesign[1]" />

                            </v-row>

                            <v-row  class="my-5 py-3 px-3">
                                <div class="text-center" style="margin-left:auto;margin-right:auto">
                                    <h3 class="synThickFont ">{{namings.engagement}}</h3>
                                    <FeedbackPercentage  :rating="feedback.engagement[0]" size="100" color="primary"/>
                                </div>
                                <FeedbackComment class="criteriaCommentBox" :comment="feedback.engagement[1]" />
                            </v-row>
                            <v-row  class="my-5 py-3 px-3">
                                <div class="text-center" style="margin-left:auto;margin-right:auto">
                                    <h3 class="synThickFont ">{{namings.originality}}</h3>
                                    <FeedbackPercentage  :rating="feedback.originality[0]" size="100" color="primary"/>
                                </div>
                                <FeedbackComment class="criteriaCommentBox" :comment="feedback.originality[1]" />
                            </v-row>
                        </div>
                    </div>


                    <div style="width:100%; margin-top:20px; margin-bottom:40px;height:1px; background-color:rgba(255,255,255,0.3); border-radius:15px"></div>

                    <div>
                        <h2 class="text-center ">Artist Biography: <router-link class="rl-no-dec syn_blue_button--text" :to="{ name: 'Artist', params: { artistId: 'e7md8b9OjhfAKAjNKzIb9ICjWQd2' }}">KUURO</router-link></h2>
                    </div>
                    <div class="mt-5 criteriaCommentBox">
                        <div class="mb-4">
                            Since debuting on Monstercat in late 2016, KUURO [cure-oh] has made a formidable impact on the bass scene racking up over 40M streams on digital platforms and touring extensively across North America including premier festival plays at Lollapalooza, Beyond Wonderland, Electric Zoo, Veld, Holy Ship!, and more.
                            Kuuro has not only been a long time favorite of Monstercat fans, but the project has also brought its unique sound to Musical Freedom, Night Mode and RAM Records as well. KUURO's music has reached far & wide and has received heavy support from the likes of Zedd, Tiesto, Zeds Dead, Jauz, Kayzo, Alison Wonderland, The Chainsmokers, Afrojack, David Guetta and many others.
                        </div>

                        <div class="mb-4">
                            2020 brings a new evolution to the KUURO project as lead producer and frontman Luke Shipstad sets out on his own path to continue his vision of melding diverse palettes of Asian influenced sounds with his cutting edge approach to electronic music.
                            Shipstad's insatiable desire for only the highest quality of music production remains. KUURO will stay true to its roots, encompassing a wide array of feelings and moods, from high energy bangers to more laid back and moody records as well.
                        </div>

                        <div class="mb-4">
                            Now creatively unleashed, Shipstad is free to create as a solo project, and has been busy preparing for his moment to bring fans the music they know and love from KUURO. This year, fans can expect multiple forthcoming releases on Monstercat, and producers can expect a follow up to the successful KUURO sounds Vol 1. Splice pack.
                        </div>

                        <div >
                            In today's global pandemic environment, one may not know where the future of live events lies, but KUURO is committed to delivering a consistent string of releases and content to keep fans craving more until he returns to a city near you.
                        </div>
                    </div>
                </div>







            </div>

        </v-container>
        <!-- <Overlay :overlay="overlay" /> -->
    </div>
</template>
<script>
import BackButton from '@/components/layout/BackButton'
// import FeedbackReportCarousel from '@/components/submissions/FeedbackReport/FeedbackReportCarousel'
import FeedbackPercentage from '@/components/submissions/FeedbackReport/FeedbackPercentage'
import FeedbackComment from '@/components/submissions/FeedbackReport/FeedbackComment'
import FeedbackPercentageSmall from '@/components/submissions/FeedbackReport/FeedbackPercentageSmall'
// import Overlay from '@/components/layout/Overlay'
export default {
    name: "FeedbackReportDemo",
    data() {
        return{
            namings: {
                overall: 'Overall',
                mixingMastering: 'Mixing & Mastering',
                toplines: 'Melodies / Vocals',
                drums: 'Drums & Percussion',
                soundDesign: 'Sound Design',
                engagement: 'Engagement / Arrangement',
                originality: 'Originality'
            },
            feedback: {
                overall: [70.5,"I think after some beefing up of your drum sound selection, some tweaks in the mix to make it a bit more dirty, beefing up the drop synths with some distortion, and revisiting the song structure so it doesn't sound copy/pasted - you're going to have a REALLY banging tune on your hands. I genuinely really enjoyed this track and was honestly one of the more impressive things I've heard from someone who isn't a professional artist. I also checked out some of your other music that you had on youtube! You're a really talented producer man! If you keep this up you're absolutely going to have a career in music."],
                mixingMastering: [60,"Mix on this a bit too sterile. It's clean! But too clean for a lot of the dirty sounds you've got in here. Something that will help fill up the mix a bit more will be revisiting the sub you have. Saturate it a bit and give it some distortion and grit. Should bring out some nice overtones and help fill the mix. Vocals need to be revisited. They sound too dry and are just sitting in the middle of the mix. Make sure to give them some side boost and width. Make sure each section of the drop has it's time upfront. Some of the sounds and sections you have are pushed a bit farther back in an uneven way compared to others. A lot of the other mix issues I have i'll address individually in the other sections here! Overall a very clean mix though - just might not stylistically fit the song!"],
                toplines: [90,"Melodies are so sick! You know i'm a sucker for those harmonic minor and arabic scales. You killed the melodic sections in here. So dope! Only suggestion I might have for you would be to add some more harmonies in the 2nd section. Play with 5ths n stuff :)The vocal is a bit boring and typical EDM Bass for me. Nothing wrong with that, I use vocals like that all the time! Just maybe work on FXing it more to make it unique and make sure it fits better in the mixdown!"],
                drums: [65,"The trap drums in this are a little boring for my taste. I think you could get more creative with the drum selection and really make the track more unique that way. The sound selection you have is SUPER clean and great sounding for sync music (TV/Movies) but if you're using this for an artist project - try to get a bit more crazy and unique. Main one to take a look at would be the snare. Maybe try layering some stuff in there / maybe have a tonal layer. Maybe try having a more meaty/'jack u' snare on the 4 and not the 2. Hats are also kind of hard to hear and should maybe cut through the mix a touch more. Also don't be afraid to get crazy with some fills in the drop section!"],
                soundDesign: [78,"Loved the sound design in this! Everything works super well together! I'm usually not a fan of bit crushers but the way you've used it in your track is pleasing! Try to get more creative with the vocal sound design and FX though. Right now they're super dry and a tad boring for how crazy everything else is. In the drop section don't be afraid to further saturate or distort your synths. Try Decapitator from Sound Toys. Should really help give some extra life to your drop section synths and bass. Also get some overtones and upper harmonics on that sub you have. Either try saturating and distorting it, or maybe replace it with some dirty 808s!"],
                engagement: [60,"Arrangement in this is good. Love the intro. When the drums first come in, the engagement the track provides is a tad boring there. Try adding some more elements, maybe foley or ear candy bits to spice up that section. 41sec - 50sec can probably be taken out - i'd just go straight into the build from there. LOVE the call and response sections you have in the drops. Just make sure each call and response are properly leveled and match each other mix-wise. The part that needs a major over haul is making sure the track doesn't feel like 1/2 track just copy/pasted twice. Was hard for me to determine how much was different about the 2nd half of the track. Definitely try to spice up the 2nd section in ways that you don't do in the first. I personally think it's fine to have the same drop twice, just make sure that you spice it up enough, give it some extra pick up with percussion elements that drive it more, new fills, etc. After the cool off section post 1st drop, i'd get the drums going again a bit sooner than you currently do, just to make sure the song doesn't feel stagnant and that it's progressing along. Don't want to bore the listener. Peoples attention spans are getting shorter every day haha! I think in the 2nd half of the drop you could give the percussion some pick up with a hi hat ride or extra shaker. Just to give it a little more movement in just the 2nd half."],
                originality: [70,"I think the originality in this song is very solid. By playing more with the sound design of your drop synths (by giving more distortion/FX) and throwing in some more original percussion elements, this track will be SUPER original and great sounding. If you really want to go the extra mile, get a real vocalist to record something for this. The vocal you have is fine, it's just somewhat trite and an overused style in bass music. Don't get me wrong, it works well - it's just something that has been done a million times before :)"]
                // overall: [70,"Very nice song, i love the vibe. I think the strongest aspect of your song is the Mix. The main emotions that this is giving me is nostalgia, especially thanks to the vocal melody. I really like your stereo image and overall idea. If you apply my suggestions, I'm sure you can get it ready to be released."],
                // mixingMastering: [75,'You did a great job cleaning up this track. Very nice stereo imaging and use of depth on it. I think what could take it to the next level is adding some distortion on the master. You can make your drops hit even harder if you roll off some highs before your drop.'],
                // toplines: [80,'I love the vocals. Such an emotional and engaging melody, very nice processing. I think you can still add a 1/4 delay on the high frequencies only. I really liked the harmonies at 2:05 and would consider adding them towards the end as well.'],
                // drums: [65,'I think that you could improve this area. You need to add more percussion as ear candy at certain sections to keep it even more interesting, especially during your breaks. Consider playing around with the panning of several short transient percussive elements. I really like your kick, it hits very hard. Very nice balance as well.'],
                // soundDesign: [70,"Okay, so your sound design is top quality but i think the sound selection is not as fresh as it could be. I can tell that I've heard those sounds somewhere else before and your song could stand out more if you differentiate yourself from the rest. The lead you have building up into the drop needs more processing, i would suggest progressively adding some grain delay and an automated reverb."],
                // engagement: [60,"This is one of the weakest aspects of the song. You need to play around with introducing new elements. I would consider taking away that pad in the background at some point because at the moment it can be heard throughout the whole song which makes it lose its impact. Sometimes less is more."],
                // originality: [70,"I know that this genre is extremely popular right now and that's why i'm going to be critical here. If you want to stand out from the crowd in a genre that's very popular, you need to differentiate yourself. That could either be via the melodies, sound design or arrangement, etc. Sometimes it helps spending entire sessions on creating random sounds with no goal in mind. Later you can then pick little elements that sound cool and add them to your tracks."]
            }
        }
    },
     components: {
        // FeedbackReportCarousel,
        FeedbackPercentage,
        FeedbackComment,
        BackButton,
        // Overlay
        FeedbackPercentageSmall

    },
}
</script>
<style>
.cBox{
    position: relative;
    width: 150px;
    height: 150px;

}
.cPercent svg{
    position: relative;
    width: 150px;
    height: 150px;
}
.cPercent circle{
    width: 150px;
    height: 150px;
    fill: none;
    stroke-width: 10;
    stroke: #000;
    transform: translate(5px, 5px);
    stroke-dasharray: 440;
    stroke-dashoffset: 440;
    stroke-linecap: round;
}
.cPercent .circleEmpty{
    stroke-dashoffset: 0;
    stroke: #f3f3f3;
}
.cPercent .circleFull{
    /* stroke-dashoffset: calc(440 - (440*87)/100); */
    stroke: #03a9f4;
}

.cPercent .cNumber {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.cPercent .cNumber h2 {
    font-size: 48px;
}
.cPercent .cNumber h2 span{
    font-size: 24px;
}

.v-progress-circular {
    margin: 1rem;
}
.rl-no-dec{
    text-decoration: none;
}
.criteriaCommentBox{
    /* #05192B = rgb(5,25,43) */
    background-color: rgba(5,25,43,0.3);
    border: rgba(255,255,255,0.3) 1px solid;
    border-radius:5px;
    padding: 10px 20px !important;
    margin-top: 10px !important;
    font-size: 0.9em !important;
}
.feedbackReport .separatorDiv{
    height:1px;
    width:100%;
    background-color: grey;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
}
.progressOverview{
    border: rgba(255,255,255,0.3) 1px solid;
    /* border:white 1px solid !important; */
    border-radius:5px;
    background-color:#05192B !important;
}
</style>